(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glass-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glass-engraving')) {
    customElements.define('glass-engraving', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.closest('form');
        if (!this.form) return;
        this.variants = JSON.parse(this.querySelector('script').textContent);
        this.fields = this.querySelector('fieldset');
        this.text = this.querySelector('textarea');
        this.file = this.querySelector('input[type="file"]');
        this.form.enctype = 'multipart/form-data';
        this.form.addEventListener('change', () => requestAnimationFrame(() => this.sync()), { signal });
        this.form.addEventListener('variant:changed', () => this.sync(), { signal });
        this.addEventListener('input', () => this.clearErrors(), { signal });
        const submit = event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!this.fields.disabled) {
            const file = this.file.files[0];
            if (!this.text.value.trim() && !file) this.text.setCustomValidity(this.dataset.emptyMessage);
            if (file && (file.size > 10 * 1024 * 1024 || !/\.(pdf|png|jpe?g|svg)$/i.test(file.name))) this.file.setCustomValidity(this.dataset.fileMessage);
          }
          if (this.form.reportValidity()) HTMLFormElement.prototype.submit.call(this.form);
        };
        this.form.addEventListener('submit', submit, { capture: true, signal });
        this.form.addEventListener('click', event => {
          if (event.target.closest('[data-pk-action="add-to-cart"]')) submit(event);
        }, { capture: true, signal });
        this.sync();
      }
      clearErrors() {
        this.text.setCustomValidity('');
        this.file.setCustomValidity('');
      }
      sync() {
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === id);
        const enabled = variant?.option1 === 'Mit Lasergravur (+6,30 €)';
        this.fields.disabled = !enabled;
        this.fields.hidden = !enabled;
        this.clearErrors();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
